module.exports = __webpack_public_path__ + "static/img/14000298.346c1a15.png";